import produce from 'immer'
import { actions } from './actions'

const initialState = {
  bibliotecasFamilia: {
    data: [],
    loading: false,
    error: '',
  },
  bibliotecaFamilia: {
    data: null,
    loading: false,
    error: '',
  },
  bibliotecaFamiliaByProducto: {
    data: [],
    loading: false,
    error: '',
  },
}

export default function bibFamiliaReducer(state = initialState, action) {
  switch (action.type) {
    case actions.BIBFAMILIA_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: true },
      }
    case actions.BIBFAMILIA_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasFamilia: {
          ...state.bibliotecasFamilia,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBFAMILIA_LOAD_FAILED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: false, error: action.error },
      }
    case actions.BIBFAMILIA_LOAD_BY_ID_REQUESTED:
      return {
        ...state,
        bibliotecaFamilia: { ...state.bibliotecaFamilia, data: null, loading: true },
      }
    case actions.BIBFAMILIA_LOAD_BY_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecaFamilia: {
          ...state.bibliotecaFamilia,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBFAMILIA_LOAD_BY_ID_FAILED:
      return {
        ...state,
        bibliotecaFamilia: { ...state.bibliotecaFamilia, loading: false, error: action.error },
      }
    case actions.BIBFAMILIA_FILTERED_LOAD_REQUESTED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, data: null, loading: true },
      }
    case actions.BIBFAMILIA_FILTERED_LOAD_SUCCEEDED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, data: action.payload, loading: false },
      }
    case actions.BIBFAMILIA_FILTERED_LOAD_FAILED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: false, error: action.error },
      }
    case actions.BIBFAMILIA_INSERT_REQUESTED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: true },
      }
    case actions.BIBFAMILIA_INSERT_SUCCEEDED:
      return {
        ...state,
        bibliotecasFamilia: {
          ...state.bibliotecasFamilia,
          data: [...state.bibliotecasFamilia.data, action.payload].sort((a, b) =>
            a.descripcion.localeCompare(b.descripcion),
          ),
          loading: false,
        },
      }
    case actions.BIBFAMILIA_INSERT_FAILED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: false, error: action.error },
      }
    case actions.BIBFAMILIA_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaFamilia: { ...state.bibliotecaFamilia, loading: true },
      }
    case actions.BIBFAMILIA_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaFamilia: {
          ...state.bibliotecaFamilia,
          data: { ...action.payload, pegatinas: state.bibliotecaFamilia.data?.pegatinas },
          loading: false,
        },
      }
    case actions.BIBFAMILIA_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaFamilia: { ...state.bibliotecaFamilia, loading: false, error: action.error },
      }
    case actions.DELETE_BIBLIOTECA_FAMILIA_REQUESTED:
      return {
        ...state,
        bibliotecasFamilia: { ...state.bibliotecasFamilia, loading: true },
      }
    case actions.DELETE_BIBLIOTECA_FAMILIA_SUCCEEDED: {
      return {
        ...state,
        bibliotecasFamilia: {
          ...state.bibliotecasFamilia,
          data: state.bibliotecasFamilia.data.filter(d => action.payload !== d.id),
          loading: false,
          reload: false,
        },
      }
    }
    case actions.DELETE_BIBLIOTECA_FAMILIA_FAILED:
      return {
        ...state,
        bibliotecasFamilia: {
          ...state.bibliotecasFamilia,
          loading: false,
          error: action.error,
        },
      }
    case actions.PEGATINA_FAMILIA_UPDATED: {
      const updatedPegatina = action.payload
      const newState = produce(state, draftState => {
        const index = draftState.bibliotecaFamilia?.data?.pegatinas?.findIndex(
          p => p.id === updatedPegatina.id,
        )
        if (index !== undefined && index !== -1) {
          draftState.bibliotecaFamilia.data.pegatinas[index] = updatedPegatina
        }
      })
      return newState
    }

    case actions.PEGATINA_FAMILIA_DELETED: {
      const idPegatinaDeleted = action.payload
      const newState = produce(state, draftState => {
        draftState.bibliotecaFamilia.data.pegatinas = draftState.bibliotecaFamilia.data.pegatinas.filter(
          p => p.id !== idPegatinaDeleted,
        )
      })
      return newState
    }

    case actions.PEGATINA_FAMILIA_INSERTED: {
      const pegatinaInserted = action.payload
      const newState = produce(state, draftState => {
        draftState.bibliotecaFamilia.data.pegatinas = [
          ...draftState.bibliotecaFamilia.data.pegatinas,
          pegatinaInserted,
        ].sort((a, b) => a.orden - b.orden)
      })
      return newState
    }
    case actions.BIBFAMILIA_PRODUCTO_BY_ID_REQUESTED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          data: null,
          loading: true,
        },
      }
    case actions.BIBFAMILIA_PRODUCTO_BY_ID_SUCCEEDED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          data: action.payload,
          loading: false,
          reload: false,
        },
      }
    case actions.BIBFAMILIA_PRODUCTO_BY_ID_FAILED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          loading: false,
          error: action.error,
        },
      }
    case actions.BIBFAMILIA_PRODUCTO_UPDATE_REQUESTED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          loading: true,
          error: '',
        },
      }
    case actions.BIBFAMILIA_PRODUCTO_UPDATE_SUCCEEDED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          data: [...action.payload],
          loading: false,
          error: '',
        },
      }
    case actions.BIBFAMILIA_PRODUCTO_UPDATE_FAILED:
      return {
        ...state,
        bibliotecaFamiliaByProducto: {
          ...state.bibliotecaFamiliaByProducto,
          loading: false,
          error: action.error,
        },
      }

    default:
      return state
  }
}
